import React from "react";
export const createSortFunction =
  (field: string, setSortParamValue: React.Dispatch<React.SetStateAction<string>>) =>
  (order: string): void => {
    setSortParamValue(order === "asc" ? `${field}:asc` : order === "desc" ? `${field}:desc` : "");
  };
